import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  Chip,
  Divider,
} from "@mui/material";
import { Close, Edit } from "@mui/icons-material";

const TaskDetailsModal = ({ task, open, onClose, onEdit }) => {
  if (!task) return null;

  const getColumnColor = (column) => {
    const colors = {
      backlog: "#9c27b0",
      "in-progress": "#2196f3",
      review: "#ff9800",
      done: "#4caf50",
    };
    return colors[column] || "#757575";
  };

  const getColumnLabel = (column) => {
    const labels = {
      backlog: "Backlog",
      "in-progress": "In Progress",
      review: "Review",
      done: "Done",
    };
    return labels[column] || column;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxHeight: "80vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          Task Details
        </Typography>
        <Button onClick={onClose} size="small" sx={{ minWidth: "auto", p: 1 }}>
          <Close />
        </Button>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 3 }}>
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
            <Typography variant="h6" fontWeight="medium" sx={{ flex: 1 }}>
              {task.title}
            </Typography>
            <Chip
              label={getColumnLabel(task.column)}
              sx={{
                backgroundColor: `${getColumnColor(task.column)}20`,
                color: getColumnColor(task.column),
                fontWeight: "bold",
                borderRadius: 2,
              }}
            />
          </Box>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
            Description
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              backgroundColor: "#f8f9fa",
              p: 2,
              borderRadius: 2,
              minHeight: "100px",
              whiteSpace: "pre-wrap",
              lineHeight: 1.6,
            }}
          >
            {task.description || "No description provided"}
          </Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
            Task Information
          </Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Task ID
              </Typography>
              <Typography variant="body1" fontWeight="medium">
                #{task.id}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Status
              </Typography>
              <Typography variant="body1" fontWeight="medium">
                {getColumnLabel(task.column)}
              </Typography>
            </Box>
          </Box>
        </Box>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
        <Button
          onClick={() => {
            onEdit();
            onClose();
          }}
          variant="contained"
          startIcon={<Edit />}
        >
          Edit Task
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TaskDetailsModal;
